import { Content } from "@/services/content/types";
import { ARTICLE_TYPES } from "@/services/content/utils";
import * as ArticleTeaser from "./article";
import * as ChronicleTeaser from "./chronicle";
import * as InterviewTeaser from "./interview";
import * as PlayTeaser from "./play";
import * as PodcastTeaser from "./podcast";

type LargeProps = {
  item: Content.Entry;
  fullWidth?: boolean;
  showLinkedContent?: boolean;
  largeHeader?: boolean;
  bigLargeArticle?: boolean;
  showLeftLine?: boolean;
  hideImage?: boolean;
  hideDownPull?: boolean;
  imagePriority?: boolean;
};
const Large = ({
  item,
  fullWidth = false,
  showLinkedContent = true,
  largeHeader = false,
  bigLargeArticle = false,
  showLeftLine = true,
  hideDownPull = false,
  hideImage = false,
  imagePriority = false,
}: LargeProps) => {
  if (
    item.sys.contentType.sys.id === "play" ||
    item.sys.contentType.sys.id === "play-episode"
  ) {
    return (
      <PlayTeaser.large
        play={item}
        largeHeader={largeHeader}
        imagePriority={imagePriority}
      />
    );
  }

  if (item.sys.contentType.sys.id === "podcast-episode") {
    return <PodcastTeaser.large podcast={item} imagePriority={imagePriority} />;
  }

  if (
    item.sys.contentType.sys.id === "article" ||
    item.sys.contentType.sys.id === "externalContent"
  ) {
    const type = (item as Content.Article).fields.type;

    if (type === ARTICLE_TYPES.CHRONICLE) {
      return (
        <ChronicleTeaser.large
          article={item}
          hideImage={hideImage}
          hideDownPull={hideDownPull}
          imagePriority={imagePriority}
        />
      );
    }

    if (type === ARTICLE_TYPES.ANALYSIS || type === ARTICLE_TYPES.COMMENT) {
      return (
        <ArticleTeaser.large
          article={item}
          showLinkedContent={showLinkedContent}
          largeHeader={largeHeader}
          bigLargeArticle={bigLargeArticle}
          showLeftLine={showLeftLine}
          imagePriority={imagePriority}
        />
      );
    }

    if (type === ARTICLE_TYPES.INTERVIEW || type === ARTICLE_TYPES.REPORTAGE) {
      return (
        <InterviewTeaser.large
          article={item}
          fullWidth={fullWidth}
          showLinkedContent={showLinkedContent}
          largeHeader={largeHeader}
          imagePriority={imagePriority}
        />
      );
    }

    return (
      <ArticleTeaser.large
        article={item}
        showLinkedContent={showLinkedContent}
        largeHeader={largeHeader}
        bigLargeArticle={bigLargeArticle}
        showLeftLine={showLeftLine}
        imagePriority={imagePriority}
      />
    );
  }

  return null;
};

export default Large;
